import maxBy from 'ramda/es/maxBy'

export const calculateMaxPoints = answer => {
    
    const q         = answer.question()
    const findMax   = maxBy(x => x.punkte)
    const startVal  = { punkte:0 }
    const maxPoints = q.points().reduce(findMax, startVal).punkte


    /**
     * if countPerAnswer() ( wertung = 'einzeln' ), the max points are the number of questions (= all correct)
     * from the selfRating will be calculated how many questions were answered correctly and how many points the 
     * user gets for that => see calculatePoints.js 
     */
    return answer.countPerAnswer() ? q.realQuestionsCount() : maxPoints
}